"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var logging_utils_1 = require("@shared/logging-utils");
(function (angularModule) {
    angularModule.factory('loggerService', [
        '$http',
        'rsEnvironment',
        function ($http, rsEnv) {
            var enableClientLogging = rsEnv.get('enableClientLogging');
            return {
                error: function (err) {
                    if (enableClientLogging) {
                        var serializedErr = (0, logging_utils_1.errorSerializer)(err);
                        $http.post('/results/logs', {
                            type: 'error',
                            error: serializedErr
                        });
                    }
                },
                info: function (message) {
                    if (enableClientLogging) {
                        $http.post('/results/logs', {
                            type: 'info',
                            value: message
                        });
                    }
                }
            };
        }
    ]);
})((0, angular_1.module)('reporting.dashboards.services'));
